import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, XCircle, ArrowRight } from 'lucide-react';
import './CheckoutStatus.css';

export default function CheckoutStatus() {
  const location = useLocation();
  const success = location.pathname.includes('/success');
  const params = new URLSearchParams(location.search);
  const orderId = params.get('order_id') || params.get('session_id') || 'your order';

  return (
    <section className="section checkout-status-page">
      <div className="container checkout-status-card surface-card">
        {success ? (
          <CheckCircle2 size={52} className="checkout-status-icon success" />
        ) : (
          <XCircle size={52} className="checkout-status-icon cancel" />
        )}
        <p className="eyebrow">{success ? 'Payment received' : 'Payment paused'}</p>
        <h1>{success ? 'Your order is confirmed.' : 'The payment was not completed.'}</h1>
        <p className="checkout-status-copy">
          {success
            ? `We’ve received your card payment for ${orderId}. Your account team will follow up with delivery and invoicing details.`
            : `The checkout was cancelled or the card was declined. You can try again from your cart or contact our team for support.`}
        </p>
        <div className="checkout-status-actions">
          <Link className="btn-primary" to="/account">
            View order history <ArrowRight size={16} />
          </Link>
          <Link className="btn-secondary" to="/products">
            Continue shopping
          </Link>
        </div>
      </div>
    </section>
  );
}
